import { makeAutoObservable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { getRootStoreInstance } from 'store/rootStore';
import { AcceptedFiles, ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { uploadFiles } from 'global/utils/uploadFiles';
import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';

export class UploadAllExhibitsPageStore {
  private _rootStore = getRootStoreInstance();
  private _isLoading = false;
  private _isFileUploadReset = false;

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public get isFileUploadReset(): boolean {
    return this._isFileUploadReset;
  }

  public setLoading(loading: boolean): void {
    this._isLoading = loading;
  }

  public setIsFileUploadReset(status: boolean): void {
    this._isFileUploadReset = status;
  }

  public async uploadAllExhibits(uploadedFiles: AcceptedFiles, effectiveDate: string): Promise<void> {
    this.setLoading(true);
    this.setIsFileUploadReset(false);

    // Get the uploaded files names
    const uploadedFilesNames = Object.keys(uploadedFiles);
    try {
      const res = await this._rootStore.carrierFileStore.getUploadExhibitUrls(
        uploadedFilesNames,
        this._rootStore.userStore.sponsorId,
        effectiveDate,
      );
      await runInAction(async () => {
        await uploadFiles(uploadedFiles, res, (): void => {
          toastManager.addToast('The exhibits were successfully uploaded', ToastColorTypes.SUCCESS);
          this.setIsFileUploadReset(true);
        });
        this.setLoading(false);
      });
    } catch (error) {
      toastManager.addToast('An error occurred during the file upload process.', ToastColorTypes.WARNING);
      this.setLoading(false);
    }
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

const UploadAllExhibitsPageStoreContext = createContext(new UploadAllExhibitsPageStore());

const useUploadAllExhibitsPageStore = (): UploadAllExhibitsPageStore => {
  return useContext(UploadAllExhibitsPageStoreContext);
};

export { UploadAllExhibitsPageStoreContext, useUploadAllExhibitsPageStore };
